<template>
    <div class="info-i" :class="infoStyleClasses">
        <a @click.prevent="onToggleClicked($event)" v-if="showI">
            <i class="icon fa fa-info" v-if="infoStyle === 'info'"></i>
            <i class="icon yellow fa fa-exclamation-triangle" v-if="infoStyle === 'warning'"></i>
        </a>
        <div class="flyout" :class="flyoutClasses">
            <div class="caret"></div>
            <div class="content">
                <slot></slot>
            </div>
        </div>
    </div>
</template>

<script>
    import { Tracking } from '../../../utils';

    export default {
        name: 'info-i',

        props: {
            direction: {
                type: String,
                'default': 'up',
            },
            shown: {
                type: Boolean,
                'default': null,
            },
            showI: {
                type: Boolean,
                'default': true,
            },
            track: {
                type: Array,
                'default': () => ([]),
            },
            infoStyle: {
                type: String,
                'default': 'info',
            },
        },

        data() {
            return {
                flyoutShown: false,
                boundAnywhereClicked: null,
            };
        },

        created() {
            this.boundAnywhereClicked = this.anywhereClicked.bind(this);
        },

        computed: {
            flyoutClasses() {
                let cls = {
                    'is-hidden': !this.shouldShow,
                };
                cls[`direction-${this.direction}`] = true;
                return cls;
            },

            shouldShow() {
                if(this.shown !== null && this.shown !== undefined) {
                    return this.shown;
                }
                return this.flyoutShown;
            },

            infoStyleClasses() {
                let classes = {};
                classes[`style-${this.infoStyle}`] = true;
                return classes;
            },
        },

        watch: {
            shown() {
                if(this.shouldShow) {
                    setTimeout(() => {
                        this.addClickAnywhereListener();
                    }, 10);
                } else {
                    this.removeClickAnywhereListener();
                }
            }
        },

        methods: {
            toggleFlyout(on = null) {
                if(on === null) {
                    on = !this.shouldShow;
                }
                this.flyoutShown = on;
                if(this.shouldShow) {
                    this.trackEvent();
                    setTimeout(() => {
                        this.addClickAnywhereListener();
                    }, 10);
                } else {
                    this.removeClickAnywhereListener();
                }
            },

            onToggleClicked(event) {
                event.preventDefault();
                this.toggleFlyout();
            },

            removeClickAnywhereListener() {
                document.removeEventListener('click', this.boundAnywhereClicked);
            },

            addClickAnywhereListener() {
                this.removeClickAnywhereListener();
                document.addEventListener('click', this.boundAnywhereClicked);
            },

            anywhereClicked() {
                if(this.shown !== null && this.shown !== undefined) {
                    this.$emit('hide');
                    return;
                }
                this.toggleFlyout(false);
            },
            trackEvent() {
                if(this.track && this.track.length) {
                    Tracking.trackEvent(this.track[0], 'infoIClicked', this.track[1]);
                }
            },
        },
    };
</script>

<style lang="scss">
    @import './info-i.scss';
</style>



// WEBPACK FOOTER //
// src/views/components/availabilities/info-i.vue